import Flickity from "flickity";

export default class AccordionContent {
  constructor() {
    this.$els = document.querySelectorAll('.js-accordion-content');
    this.$els.forEach(($el) => {
      const $carousel = $el.querySelector('.js-accordion-content-carousel');

      if ($carousel) {
        const carousel = new Flickity($carousel, {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          imagesLoaded: true,
        });
      }
    });
  }
}
